const state = {
    employeeTrainings: [],
    employeeTrainingId: [],
    loading: false
};

export default state;